import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PlayblastRecordNsk = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M12 22.7999C17.9647 22.7999 22.8 17.9646 22.8 12C22.8 6.03528 17.9647 1.19995 12 1.19995C6.03532 1.19995 1.2 6.03528 1.2 12C1.2 17.9646 6.03532 22.7999 12 22.7999Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PlayblastRecordNsk.displayName = 'PlayblastRecordNsk';
